import React from "react";
import PropTypes from "prop-types";

const THead = ({
    children,
    className,
    testSection,
    ...props
}) => {
    return <thead data-test-section={testSection} className={className} {...props}>{children}</thead>;
};

THead.propTypes = {
    /** Should be a `Table.TR` component */
    children: PropTypes.node,
    /** CSS class names. */
    className: PropTypes.string,
    /** Hook for automated JavaScript tests */
    testSection: PropTypes.string,
};

THead.displayName = "Table.THead";

export default THead;
